import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import StarburstDecor from '../components/ui/StarburstDecor';
import { companyInfo, services } from '../data/mock';
import { toast } from 'sonner';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    email: '',
    serviceName: '',
    projectBudget: '',
    projectDetails: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Thank you! We will get back to you soon.');
    setFormData({
      fullName: '',
      companyName: '',
      email: '',
      serviceName: '',
      projectBudget: '',
      projectDetails: ''
    });
  };

  return (
    <Layout>
      {/* Hero Section */}
      <section className="bg-white py-12 relative">
        <div className="container-main">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Headlines */}
            <div>
              <h1 className="font-display font-bold leading-none mb-6">
                <span className="text-lime text-5xl md:text-6xl lg:text-7xl italic">LET'S WORK</span>
                <br />
                <span className="text-navy text-5xl md:text-6xl lg:text-7xl">TOGETHER</span>
              </h1>
              <p className="text-gray-600 text-sm leading-relaxed max-w-md">
                Our focus is on creating visually appealing brands, websites, and products for technology startups and companies. Our focus is on creating visually appealing brands,
              </p>
            </div>

            {/* Right Side - Form */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 relative">
              {/* Starburst decoration */}
              <div className="absolute -top-8 -right-8 z-10">
                <StarburstDecor size={100} color="lime" />
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-bold text-navy mb-2">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Jonathon marry coper"
                    className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                    required
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-navy mb-2">Company name</label>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      placeholder="welmark group"
                      className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-navy mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="welmarkgroup@gmail.com"
                      className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                      required
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-navy mb-2">Service name</label>
                    <input
                      type="text"
                      name="serviceName"
                      value={formData.serviceName}
                      onChange={handleChange}
                      placeholder="UI/UX Design"
                      className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-navy mb-2">Project budget</label>
                    <input
                      type="text"
                      name="projectBudget"
                      value={formData.projectBudget}
                      onChange={handleChange}
                      placeholder="20k"
                      className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-navy mb-2">Project Details</label>
                  <input
                    type="text"
                    name="projectDetails"
                    value={formData.projectDetails}
                    onChange={handleChange}
                    placeholder="Details"
                    className="w-full border-b-2 border-gray-200 py-2 text-gray-600 focus:outline-none focus:border-lime transition-colors bg-transparent"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-full text-sm font-medium transition-all hover:bg-opacity-90"
                >
                  Let's Talk
                  <span className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactPage;
